import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import "./searchStyle.css";

import { fetchAutocompleteRequest, setSearchLoading, setSearchParam, setSelectedCategory } from "@/redux/SRP/srpSearchSlice";
import { fetchRecentSearch, updateRecentSearch } from "@/redux/SRP/recentSearchSlice";

import { fetchSRPInitialLoad, setSRPInitialLoad } from "@/redux/SRP/srpSlice";

import { baseApi } from "@/api/apiConfig";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import PropertySuggestIcon from "../../../../public/assets/svg/faq/PropertySuggestIcon";
import { getSearchUrl, saveRecentSearch, deleteRecentSearch } from "@/api/savedSearch";
import { getUserRecentSearch } from "@/api/home";
import { useLocation } from "react-router";
import { recentSearchLocalSave } from "./saveSearchLocal";
import { addAreaMax, addAreaMin, addAuctionEndingToday, addBathrooms, addBedrooms, addBrokerCoOp, addBuiltYearMax, addBuiltYearMin, addCampaign, addCampaignId, addCampaignType, addCashOnly, addIsPartOfCampaign, addListingType, addMapParam, addMarketingPhase, addNewToHubzu, addNobuyerpremium, addOffers, addOwnItNow, addPriceMax, addPriceMin, addSearchBy, resetCategory, resetFeatured, resetOccupancy, resetPropertyStatus, resetPropertySubType, resetSpecialAssetsTypes } from "@/redux/SRP/propertiesSlice";
import { formUrl } from "@/components/srp/searchParams";
import { getPropertyURL, navigateToProperty } from "@/utils/propertyNavigation";
import { markInternalNavigation } from "@/utils/attributionCapture";

const SearchBar = ({ isSearchFromHome }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { savedSearch } = useSelector((state) => state.savedSearch);
  const globalPopup = useSelector((state) => state.login);
  const userEmailId = useSelector((state) => state.user?.user?.userEmailId);
  const webCMS = useSelector(
    (state) => state.cms?.data?.global?.results?.[0]?.["shared"]?.["navLinks"]
  );
  const {
    autocompleteData: autocomplete,
    autocompleteError,
    searchParam,
    selectedCategory,searchLoading
  } = useSelector((state) => state.srpSearch);

  const [getShow, setShow] = useState(false);
  const [error, setError] = useState("");
  const [searchBarFocus, setSearchBarFocus] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [recentSearchLocal, setRecentSearchLocal] = useState(() => {
    const stored = localStorage.getItem("recentSearch");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;
      setIsMobile(newIsMobile);

      // Reset category to Browse All when switching to mobile
      if (newIsMobile && selectedCategory !== "Browse All") {
        dispatch(setSelectedCategory("Browse All"));
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [selectedCategory]);

  const buyDropDown = [
    { id: 0, name: "Browse All", routerPath: "/auctions" },
    // {
    //   id: 1,
    //   name: webCMS?.realEstateAuctions || "Real Estate Auctions",
    //   routerPath: "/auctions?listingType=AUCN",
    // },
    { id: 2, name: webCMS?.bankOwned || "Bank Owned", routerPath: "/bank-owned" },
    {
      id: 3,
      name: webCMS?.signatureSellerProperties || "Hubzu Signature Homes",
      routerPath: "/auctions?sid=signature-seller",
    },
    {
      id: 4,
      name: webCMS?.offMarketProperties || "Off Market Properties",
      routerPath: "/auctions?sid=offmarket-properties",
    },
    { id: 5, name: webCMS?.commercialProperties || "Commercial Properties", routerPath: "/commercial" },
    { id: 6, name: webCMS?.CWCOTSecondChance ? webCMS?.CWCOTSecondChance : "CWCOT Second Chance", routerPath: "/auctions?listingType=AUCN&category=secondchance" },
    { id: 7, name: webCMS?.foreclosure || "Foreclosure", routerPath: "/foreclosures" },
    { id: 8, name: webCMS?.shortSale || "Short Sale", routerPath: "/short-sale" },
    { id: 9, name: webCMS?.traditionalSale || "Traditional Sale", routerPath: "/traditional-sale" },
  ];
    const getCategory = () => {
      switch (selectedCategory) {
        case "Bank Owned":
          return {category: "bankowned"};
        case "Hubzu Signature Homes":
          return {sid: "signature-seller"};
        case "Off Market Properties":
          return {sid : "offmarket-properties"};
        case "Commercial Properties":
          return {category:"commercial"};
        case "CWCOT Second Chance":
          return {category:"secondchance"};
        case "Foreclosure":
          return {category:"foreclosure"};
        case "Short Sale":
          return {category:"SHRT_SALE"};
        case "Traditional Sale":
          return {listingType:"TRNL"};
        default:
          return "";
      }
    };

    const getCategoryFromURL = (url) => {
      if (!url) return "Browse All";

      if (url.includes('category=bankowned')) return "Bank Owned";
      if (url.includes('sid=signature-seller')) return "Hubzu Signature Homes";
      if (url.includes('sid=offmarket-properties')) return "Off Market Properties";
      if (url.includes('category=commercial')) return "Commercial Properties";
      if (url.includes('category=foreclosure')) return "Foreclosure";
      if (url.includes('category=SHRT_SALE')) return "Short Sale";
      if (url.includes('category=secondchance')) return "CWCOT Second Chance";
      if (url.includes('listingType=TRNL')) return "Traditional Sale";

      return "Browse All";
    };

  const onNavigatePDP = (id) => {
    var newWindow = window.open(`/property/${id}`);
    newWindow.selectedPDP = { propertyId: id };
  };

  document.addEventListener("click", (event) => {
    if (error) {
      const errorHome = document.getElementById("errorHome");
      const errorMenu = document.getElementById("errorHome");
      if (error && errorHome && !errorHome.contains(event.target)) {
        setError("");
      }
      if (error && errorMenu && !errorMenu.contains(event.target)) {
        setError("");
      }
    }
    if (searchBarFocus) {
      const searchHome = document.getElementById("searchHome");
      const searchMenu = document.getElementById("searchHomeheader");
      if (
        !searchParam &&
        isSearchFromHome &&
        searchHome &&
        !searchHome.contains(event.target)
      ) {
        setSearchBarFocus(false);
        setShow(false);
      } else if (
        !searchParam &&
        !isSearchFromHome &&
        searchMenu &&
        !searchMenu.contains(event.target)
      ) {
        setSearchBarFocus(false);
        setShow(false);
      }
    }
    // Close dropdown when clicking outside
    if (showDropdown) {
      const dropdownElement = event.target.closest('.dropdown');
      if (!dropdownElement) {
        setShowDropdown(false);
      }
    }
  });
  const resetAllFilters = () => {
    dispatch(resetPropertySubType());
    dispatch(resetCategory());
    dispatch(resetPropertyStatus());
    dispatch(resetOccupancy());
    dispatch(resetSpecialAssetsTypes());
    dispatch(resetFeatured());
    dispatch(addPriceMin(0));
    dispatch(addPriceMax(0));
    dispatch(addAreaMin(""));
    dispatch(addAreaMax(""));
    dispatch(addBuiltYearMin(0));
    dispatch(addBuiltYearMax(0));
    dispatch(addBedrooms(""));
    dispatch(addBathrooms(""));
    dispatch(addListingType({ value: "", isUpdate: false }));
    dispatch(addNewToHubzu({ value: "", isUpdate: false }));
    dispatch(addMarketingPhase({ value: "", isUpdate: false }));
    dispatch(addAuctionEndingToday({ value: "", isUpdate: false }));
    dispatch(addOwnItNow({ value: "", isUpdate: true }));
    dispatch(addNobuyerpremium({ value: "", isUpdate: true }));
    dispatch(addBrokerCoOp({ value: "", isUpdate: true }));
    dispatch(addCashOnly({ value: "", isUpdate: true }));
    dispatch(addCampaign({ value: "", isUpdate: false }));
    dispatch(addCampaignId({ value: "", isUpdate: false }));
    dispatch(addCampaignType({ value: "", isUpdate: false }));
    dispatch(addIsPartOfCampaign({ value: "", isUpdate: false }));
    dispatch(addOffers({ value: "", isUpdate: false }));
    dispatch(addSearchBy({ value: "", isUpdate: false }));
    dispatch(addMapParam(""));
  };

  const onSelection = async (label, endPoint, type, id, Showlabel, searchBy, stateCode) => {
    const openPDP =
      type === "MLS_ID" ||
      type === "PROPERTY_ID_ALIASES" ||
      type === "PDP" ||
      type === "ADDRESS" ||
      type === "PROP_CATEGORY_WITH_ADDRESS" ||
      type === "LISTING_TYPE" ||
      type === "SELLER_CODE" ||
      type === "OFFMARKET";
    if (openPDP) {
      let propertyId = "";
      if (id.includes("property/")) {
        let property = id?.split("/")[1];
        if (property.includes("-")) {
          property = property?.split("-")[0];
        }
        propertyId = property;
      } else {
        propertyId = id;
      }
      let searchBy = label + ", " + Showlabel;
      const response = await getSearchUrl({id, type});
      if (response?.type === 'VALID') {
        const categoryPrefix = selectedCategory !== "Browse All" ? `${selectedCategory} - ` : "";
        recentSearchLocalSave({searchBy: categoryPrefix + searchBy, searchURI: `/${response?.searchURI}`?.replace('//', '/'), isLoggedIn: userEmailId || globalPopup?.isUserSubscribed, category: selectedCategory, propertyCategory: response?.propertyCategory, propertyStatus: response?.propertyStatus});
        navigateToProperty(`/${response?.searchURI}`, response?.propertyCategory, response?.propertyStatus);
      }
      dispatch(setSearchParam(""));
      return;
    } else if (type === "GPS") {
      onLocationBtnClicked();
    } else if (type === "RECENT") {
      var EP = endPoint;
      if (endPoint.includes("?")) {
        EP = endPoint?.split("?");
        EP = EP[0].substring(0);
      }
      if (id.charAt(0) === "/") {
        id = id.slice(1);
      }
      dispatch(setSearchParam(""));
    } else {
      dispatch(setSRPInitialLoad(true));
      trackButtonClick({
        eventName: "search_result_click",
        eventCategory: "Home Page 2.0",
        eventSource: `Search Success Click`,
        eventLabel: `Search term: ${label} | type: Recent search`,
        eventParams: { search_term: label, trigger: "suggestion_click_auto" },
      });

      let url = '';
      const breakEndPoint = endPoint.split('/');
      if (type === 'ZIP') {
        url = `/${breakEndPoint[breakEndPoint.length - 1]}/auctions`;
      } else if(type === 'COUNTY') {
        url = `/${breakEndPoint[breakEndPoint.length - 2]}/${breakEndPoint[breakEndPoint.length - 1]}/auctions`;
      } else if(type === 'CITY' || type === "STATE") {
        url = `/${endPoint}`;
      } else {
        url = `/${endPoint}`;
      }
      url = url.replaceAll('(', '');
      url = url.replaceAll(')', '');
      url = url.replaceAll(' ', '-');
      url = url.replaceAll('?', '');
      url = url.replaceAll('//', '/');

      const response = await getSearchUrl({id, type});
      if (response?.type === 'VALID') {

          let searchUrl = response?.searchURI;
          const params = getCategory();
          if (params.category) {
            searchUrl = searchUrl + `?category=${params.category}`;
          } else if (params.sid) {
            searchUrl = searchUrl + `?sid=${params.sid}`;
          } else if (params.listingType) {
            searchUrl = searchUrl + `?listingType=${params.listingType}`;
          }
          const categoryPrefix =
            selectedCategory !== "Browse All" ? `${selectedCategory} - ` : "";

          recentSearchLocalSave({
            searchBy: categoryPrefix + searchBy,
            searchURI: searchUrl,
            isLoggedIn: userEmailId || globalPopup?.isUserSubscribed,
            category: selectedCategory,
            propertyCategory: response?.propertyCategory,
            propertyStatus: response?.propertyStatus
          });

          if (pathname === `/${response.searchURI}`) {
            resetAllFilters();
            dispatch(fetchSRPInitialLoad({url: `/${searchUrl}${searchUrl?.includes("?")?
              "&":"?"}rect=true&sort=MostPopular`, pageNumber: 1}));
          }
          markInternalNavigation();
          navigate(getPropertyURL(`/${searchUrl}`, response?.propertyCategory, response?.propertyStatus));
      }
    }
  };

  const getAutocompleteData = (query) => {
    dispatch(setSearchParam(query));
    if (query.length > 1) {
      setShow(true);
      dispatch(fetchAutocompleteRequest({ query, category: selectedCategory }));
    } else {
      setShow(false);
    }
    setError("");
  };

  const renderSingleAutocomplete = (row) => {
    const jsonResult = JSON.parse(row.jsonResult);
    const stateCode = jsonResult.state ? jsonResult.state : "";
    const endPoint = {
      CITY: `${row.level2Text.toLowerCase()}/${row.level1Text.toLowerCase()}/auctions`,
      PLACE: `searchResult/${row.type}/${
        row.id
      }/${row.level2Text.toLowerCase()}`,
      ZIP: `searchResult/zip/${row.id}/${row.level1Text.toLowerCase()}`,
      COUNTY: `searchResult/county/${
        row.id
      }/${row.level2Text.toLowerCase()}/${row.level1Text.toLowerCase()}`,
      STATE: `${stateCode.toLowerCase()}/auctions`,
      NEIGHBORHOOD: `searchResult/${row.type}/${
        row.id
      }/${row.level2Text.toLowerCase()}`,
      MCDS: `searchResult/${row.type}/${
        row.id
      }/${row.level2Text.toLowerCase()}`,
      PROPERTY_ID_ALIASES: `property/getNewPdpDetails/${row.id}`,
      MLS_ID: `property/getNewPdpDetails/${row.id}`,
      ADDRESS: `property/getNewPdpDetails/${row.id}`,
      PROP_CATEGORY_WITH_ADDRESS:`property/getNewPdpDetails/${row.id}`,
      LISTING_TYPE:`property/getNewPdpDetails/${row.id}`,
      SELLER_CODE:`property/getNewPdpDetails/${row.id}`,
      OFFMARKET:`property/getNewPdpDetails/${row.id}`,
    };
    const subText = {
      PROPERTY_ID_ALIASES: `Property ID ${row.id}`,
      MLS_ID: `MLS ID ${row.label}`,
      PROP_CATEGORY_WITH_ADDRESS: `Property ${row.label}`,
      LISTING_TYPE: `Listing ${row.label}`,
      SELLER_CODE: `Seller ${row.label}`,
      OFFMARKET: `Off Market ${row.label}`,
    };
    const Showlabel = row.level2Text;

 return (
      <div
        id={`autocomplete-suggestion-${row?.type}-${row?.id}`}
        className="search-option search-option-container"
        key={`search-result-${row?.id}`}
        onClick={() => {
          dispatch(setSearchParam((row?.level1Text ? `${row?.level1Text}${row?.level2Text ? ", " : ""}` : "" ) + (row?.level2Text ? row?.level2Text : "")));
          onSelection(
            row.label ? row.label : row.value,
            endPoint[row.type] ? endPoint[row.type] : row?.searchURI,
            row.type,
            row.id,
            Showlabel,
            (row?.level1Text ? `${row?.level1Text}${row?.level2Text ? ", " : ""}` : "" ) + (row?.level2Text ? row?.level2Text : ""),
          )}
        }
      >
        <div className="search-option-content">
          <div className="search-icon-container">
            <PropertySuggestIcon />
          </div>
          <span className="search-bar-label">
            {row?.level1Text
              ? `${row?.level1Text}${row?.level2Text ? ", " : ""}`
              : ""}
            {row?.level2Text ? row?.level2Text : ""}
          </span>
        </div>
      </div>
    );
  };

  const renderAllAutocomplete = () => {
    if (
      (autocomplete && Object.keys(autocomplete)?.length === 0) ||
      autocompleteError !== ""
    ) {
      return (
        <div
          className={`search__control search__menu search__menu-list p-3 ${
            isSearchFromHome ? "search__control--home " : ""
          }`}
        >
          {getLocationRecentSearch()}
        </div>
      );
    }
    const parseAutocomplete = searchLoading ? [] : [].concat(
      autocomplete?.Place?.STATE,
      autocomplete?.Place?.CITY,
      autocomplete?.Place?.PLACE,
      autocomplete?.Place?.NEIGHBORHOOD,
      autocomplete?.Place?.COUNTY,
      autocomplete?.Place?.ZIP,
      autocomplete?.Place?.MCDS,
      autocomplete?.["Available Listings"]?.MLS_ID,
      autocomplete?.["Available Listings"]?.PROPERTY_ID_ALIASES,
      autocomplete?.["Available Listings"]?.PROP_CATEGORY_WITH_ADDRESS,
      autocomplete?.["Available Listings"]?.LISTING_TYPE,
      autocomplete?.["Available Listings"]?.SELLER_CODE,
      autocomplete?.["Available Listings"]?.OFFMARKET,
      autocomplete?.["Property Address"]?.ADDRESS
    );
    const searchList = []
    if (autocomplete?.RECENT_SEARCH?.RECENT_SEARCH?.length > 0) {
      searchList.concat(
        autocomplete?.RECENT_SEARCH?.RECENT_SEARCH.map(recentItem => {
          return {...recentItem, value: recentItem?.id, searchURI: recentItem?.label, id: recentItem?.label, dataType: "RECENT"}
        }),
      );
    }
    if (autocomplete?.SAVE_SEARCH?.SAVE_SEARCH?.length > 0) {
      searchList.concat(
        autocomplete?.SAVE_SEARCH?.SAVE_SEARCH.map(savedItem => {
          return {...savedItem, searchName: savedItem?.id, id: savedItem?.label, dataType: "SAVED"}
        }),
      );
    }
    return (
      <div
        className={`search__control search__menu search__menu-list p-3 ${
          isSearchFromHome ? "search__control--home" : ""
        }`}
      >
        {getLocationRecentSearch()}
        {searchList && searchList.length > 0 && searchList.map((row) => getLocRecentSavedItem(row))}
        {parseAutocomplete.map((row) => renderSingleAutocomplete(row))}
      </div>
    );
  };

  const onLocationBtnClicked = () => {
    markInternalNavigation();
    navigate('/near-me');
  };

  const onRecentItemClicked = (recentItem) => {
    const formData = new FormData();
    formData.append('searchBy', recentItem.value);
    formData.append('baseSearchUrl', recentItem.searchURI);
    formData.append('searchURI', recentItem.searchURI);
    baseApi.post(`/portal/saveRecentSearch`, formData).then(() => dispatch(fetchRecentSearch()));


    const type = recentItem?.type;
    let id = recentItem.id;
    if (recentItem.type === 'PDP' || recentItem?.id?.includes('property')) {
      if (recentItem.id.charAt(0) === '/') {
        id = recentItem.id.slice(1);
      }
    }
    const openPDP =
      type === 'MLS_ID' ||
      type === 'PROPERTY_ID_ALIASES' ||
      type === 'PDP' ||
      type === 'ADDRESS' ||
      type === 'PROP_CATEGORY_WITH_ADDRESS' ||
      type === 'LISTING_TYPE' ||
      type === 'SELLER_CODE' ||
      type === 'OFFMARKET';
    if (openPDP) {
      let propertyId = '';
      if (id.includes('property/')) {
        let property = id?.split('/')[1];
        if (property.includes('-')) {
          property = property?.split('-')[0];
        }
        propertyId = property;
      } else {
        propertyId = id;
      }
      recentSearchLocalSave({searchBy: recentItem?.defaultSearchText, value: recentItem?.value, searchURI: recentItem?.searchURI, isLoggedIn: userEmailId || globalPopup?.isUserSubscribed, category: recentItem?.category, propertyCategory: recentItem?.propertyCategory, propertyStatus: recentItem?.propertyStatus});
      navigateToProperty(`/property/${propertyId}`, recentItem?.propertyCategory, recentItem?.propertyStatus);
      return;
    } else {
        // Check if recent search has a category (not Browse All)
    const hasCategory = getCategoryFromURL(recentItem?.id) && getCategoryFromURL(recentItem?.id) !== "Browse All";

    // If recent search has NO category, apply selected dropdown filter
    // If recent search HAS category, keep it (ignore dropdown)
    let finalCategory = hasCategory ? getCategoryFromURL(recentItem?.id) : selectedCategory;
    let finalSearchBy = recentItem?.defaultSearchText || recentItem?.value;
    let finalSearchURI = recentItem?.searchURI;

    // Apply dropdown filter only if recent search has no category
    if (!hasCategory && selectedCategory !== "Browse All" && !finalSearchURI?.includes('?') && !finalSearchURI?.includes('property')) {
      const params = getCategory();
      if (params.category) {
        finalSearchURI = `${finalSearchURI}?category=${params.category}`;
      } else if (params.sid) {
        finalSearchURI = `${finalSearchURI}?sid=${params.sid}`;
      } else if (params.listingType) {
        finalSearchURI = `${finalSearchURI}?listingType=${params.listingType}`;
      }
      finalSearchBy = `${selectedCategory} - ${finalSearchBy}`;
    }

    // Restore category
    if (finalCategory && finalCategory !== "Browse All") {
      dispatch(setSelectedCategory(finalCategory));
    }
      recentSearchLocalSave({searchBy: finalSearchBy, value: finalSearchBy, searchURI: finalSearchURI, isLoggedIn: userEmailId || globalPopup?.isUserSubscribed, category: finalCategory, propertyCategory: recentItem?.propertyCategory, propertyStatus: recentItem?.propertyStatus});
      if(finalSearchURI?.includes('property')){
        navigateToProperty(finalSearchURI, recentItem?.propertyCategory, recentItem?.propertyStatus);
      }else{
        markInternalNavigation();
        navigate(getPropertyURL(finalSearchURI, recentItem?.propertyCategory, recentItem?.propertyStatus))
      }
    }
  }

  const onRemoveRecentSearch = async (e, row) => {
    e.stopPropagation();

    // Call API to delete from backend for both logged-in and non-logged-in users
    try {
      await deleteRecentSearch(row.id);
      if (userEmailId || globalPopup?.isUserSubscribed) {
        dispatch(fetchRecentSearch());
      }
    } catch (error) {
      console.error('Error deleting recent search:', error);
    }

    // Update local storage
    if (recentSearchLocal?.cookieElements) {
      const updatedElements = recentSearchLocal.cookieElements.filter(item => item.id !== row.id);
      const updatedRecentSearch = {
        ...recentSearchLocal,
        cookieElements: updatedElements
      };
      localStorage.setItem("recentSearch", JSON.stringify(updatedRecentSearch));
      setRecentSearchLocal(updatedRecentSearch);
    }
  };

  const getLocRecentSavedItem = (row) => {
    if (!(row.value || row.searchName || row.label || row.dataType === 'GPS')) {
      return;
    }
    return(
        <div
          id={`search-${row.dataType?.toLowerCase()}-${row.value || row.searchName || row.label || 'item'}`}
          className="search-option search-option-container"
          key={row?.id || `${row.dataType}-${Math.random()}`}
          onClick={() => {
            trackButtonClick({
              eventName: "search_suggestion_click",
              eventCategory: "Home Page 2.0",
              eventSource:
                row.dataType === "GPS"
                  ? "Use Current Location click"
                  : row.dataType === "RECENT"
                  ? "Search result click"
                  : "Saved Search click",
              eventLabel: `Search term: ${
                row.label || row.searchName || row.value
              } | type: Recent search`,
              eventParams: {
                suggestion_type:
                  row.dataType === "GPS"
                    ? "current_location"
                    : row.dataType === "RECENT"
                    ? "recent"
                    : "saved",
              },
            });
            resetAllFilters();
            if(row.dataType === 'RECENT') {
              onRecentItemClicked(row);
            } else if(row.dataType === 'SAVED') {
              // if (!row?.baseSearchUrl && row?.label?.includes('searchResult')) {
              //   let baseSearchUrl = '';
              //   const values = row?.label?.split('/');
              //   if(values && row?.label?.includes('city')) {
              //     baseSearchUrl = `/${values[values?.length-2]}/${values[values?.length-1]}/auctions`;
              //   } else if(values && row?.label?.includes('state') || row?.label?.includes('zip')) {
              //     baseSearchUrl = `/${values[values.length-1]}/auctions`;
              //   } else if(values) {
              //     baseSearchUrl = `/${values[values.length-1]}/auctions`;
              //   }
              //   recentSearchLocalSave({searchBy: row?.label || row?.searchName || row?.value, searchURI: baseSearchUrl, isLoggedIn: userEmailId || globalPopup?.isUserSubscribed, category: row?.category});
              //   navigate(baseSearchUrl)
              // } else {
              //   navigate(`/${row?.baseSearchUrl}`)
              // }
             const searchUrl =  formUrl(row)
             markInternalNavigation();
             navigate(searchUrl)
            } else if(row.dataType === 'GPS') {
              onLocationBtnClicked();
            } else {
              let id = row.id;
              if (row.type === "PDP" || row?.id?.includes("property")) {
                if (row.id.charAt(0) === "/") {
                  id = row.id.slice(1);
                }
              }
              onSelection(row.label || row.searchName, row.searchURL, row.type, id, "", row.value || row.searchName || row.label, "")
            }
            dispatch(setSearchParam(''));
        }}
      >
        <div className="search-option-content">
          <div className="search-icon-container">
            {row?.type === "GPS" ? (
              <i className="fa fa-location-arrow" style={{ color: "#ADC4DA", fontSize: "18px" }}></i>
            ) : row?.searchName ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <path fill="#F25D49" fillRule="evenodd" d="M12.696 1.8c-1.236 0-2.333.513-3.284 1.35l-.223.205-.187.187-.183-.184c-.072-.07-.146-.138-.222-.205C7.653 2.314 6.57 1.8 5.347 1.8 2.375 1.8 0 4.112 0 6.97c0 2.885 1.669 5.388 4.397 7.514.929.724 1.92 1.353 2.91 1.887.26.14.508.267.738.379l.414.195c.083.038.148.066.193.085l.33.138.336-.126c.281-.106.753-.31 1.353-.612.995-.502 1.99-1.105 2.923-1.812C16.328 12.545 18 10 18 6.969 18 4.106 15.664 1.8 12.696 1.8zm0 1.8c1.98 0 3.504 1.505 3.504 3.37 0 2.371-1.365 4.448-3.694 6.214-.839.636-1.742 1.183-2.646 1.639l-.232.115c-.152.073-.297.141-.435.204l-.178.077.02.01c-.262-.124-.556-.272-.874-.443-.907-.489-1.815-1.065-2.658-1.722C3.17 11.245 1.8 9.192 1.8 6.969 1.8 5.117 3.358 3.6 5.348 3.6c.72 0 1.411.328 2.054.898.151.135.292.276.423.421l.19.22c.098.121.29.38.303.397l.68.787.681-.785c.016-.017.208-.277.306-.396.183-.223.388-.44.617-.64.65-.573 1.353-.902 2.094-.902z"/>
              </svg>
            ) : (

<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.81772 10.7067C8.51777 10.7067 10.7066 8.51783 10.7066 5.81777C10.7066 3.11772 8.51777 0.928888 5.81772 0.928888C3.11766 0.928888 0.928833 3.11772 0.928833 5.81777C0.928833 8.51783 3.11766 10.7067 5.81772 10.7067Z" stroke="#ADC4DA" stroke-width="1.85778" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.929 11.9289L9.27063 9.27056" stroke="#ADC4DA" stroke-width="1.85778" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            )}
          </div>
          <span className="search-bar-label">
            {row.value || row.searchName || row.label}
          </span>
        </div>
        {row.dataType === 'RECENT' && (
          <button
            id={`remove-recent-${row.value || row.searchName || row.label || 'item'}`}
            className="search-remove-btn"
            onClick={(e) => onRemoveRecentSearch(e, row)}
            aria-label="Remove recent search"
          />
        )}
      </div>
    );
  }

  const getLocationRecentSearch = () => {
    const data = [];

    // Add GPS location first
    const gpsData = {
      label: "Use Current Location",
      subLabel: "",
      type: "GPS",
      dataType: "GPS",
      data: "",
      propType: "GPS",
    };
    data.push(getLocRecentSavedItem(gpsData));

    // Add recent searches with header if they exist
    const recentItems = [];
    if (
      !(
        searchParam !== "" &&
        autocomplete &&
        Object.keys(autocomplete).length > 0
      ) && recentSearchLocal?.cookieElements?.length > 0 && Object.keys(recentSearchLocal?.cookieElements).length > 0
    ) {
      recentItems.push(...recentSearchLocal?.cookieElements?.slice(0, 5).map(recentItem => ({...recentItem, dataType: "RECENT"})));
    }

    if (recentItems.length > 0) {
      data.push(
        <div key="recent-header" className="recent-searches-header-home">
          Recent searches
        </div>
      );
      data.push(...recentItems.map((row) => getLocRecentSavedItem(row)));
    }

    // Add saved searches
    if (
      !(
        searchParam !== "" &&
        autocomplete &&
        Object.keys(autocomplete).length > 0
      ) && Object.keys(savedSearch).length > 0
    ) {
      const savedItems = savedSearch.slice(0, 5).map(savedItem => ({...savedItem, dataType: "SAVED"}));
      data.push(...savedItems.map((row) => getLocRecentSavedItem(row)));
    }

    return data;
  };
  const hitFirstAutocomplete = () => {
    const parseAutocomplete = [].concat(
      autocomplete?.Place?.STATE,
      autocomplete?.Place?.CITY,
      autocomplete?.Place?.PLACE,
      autocomplete?.Place?.NEIGHBORHOOD,
      autocomplete?.Place?.COUNTY,
      autocomplete?.Place?.ZIP,
      autocomplete?.Place?.MCDS,
      autocomplete?.["Available Listings"]?.MLS_ID,
      autocomplete?.["Available Listings"]?.PROPERTY_ID_ALIASES,
      autocomplete?.["Available Listings"]?.PROP_CATEGORY_WITH_ADDRESS,
      autocomplete?.["Available Listings"]?.LISTING_TYPE,
      autocomplete?.["Available Listings"]?.SELLER_CODE,
      autocomplete?.["Available Listings"]?.OFFMARKET,
      autocomplete?.["Property Address"]?.ADDRESS
    );
    const row = parseAutocomplete[0];
    dispatch(setSearchParam((row?.level1Text ? `${row?.level1Text}${row?.level2Text ? ", " : ""}` : "" ) + (row?.level2Text ? row?.level2Text : "")));
    const jsonResult = JSON.parse(row.jsonResult);
    const stateCode = jsonResult.state ? jsonResult.state : "";
    const endPoint = {
      CITY: `${row.level2Text.toLowerCase()}/${row.level1Text.toLowerCase()}/auctions`,
      PLACE: `searchResult/${row.type}/${
        row.id
      }/${row.level2Text.toLowerCase()}`,
      ZIP: `searchResult/zip/${row.id}/${row.level1Text.toLowerCase()}`,
      COUNTY: `searchResult/county/${
        row.id
      }/${row.level2Text.toLowerCase()}/${row.level1Text.toLowerCase()}`,
      STATE: `${stateCode.toLowerCase()}/auctions`,
      NEIGHBORHOOD: `searchResult/${row.type}/${
        row.id
      }/${row.level2Text.toLowerCase()}`,
      MCDS: `searchResult/${row.type}/${
        row.id
      }/${row.level2Text.toLowerCase()}`,
      PROPERTY_ID_ALIASES: `property/getNewPdpDetails/${row.id}`,
      MLS_ID: `property/getNewPdpDetails/${row.id}`,
      ADDRESS: `property/getNewPdpDetails/${row.id}`,
      PROP_CATEGORY_WITH_ADDRESS:`property/getNewPdpDetails/${row.id}`,
      LISTING_TYPE:`property/getNewPdpDetails/${row.id}`,
      SELLER_CODE:`property/getNewPdpDetails/${row.id}`,
      OFFMARKET:`property/getNewPdpDetails/${row.id}`,
    };
    const Showlabel = row.level2Text;

    trackButtonClick({
      eventName: `search_button_click`,
      eventCategory: "Home Page 2.0",
      eventSource: `Mannual / Recent Search click`,
      eventLabel: `Search term: ${row.label}`,
    });

    onSelection(
      row.label ? row.label : row.value,
      endPoint[row.type] ? endPoint[row.type] : row?.searchURI,
      row.type,
      row.id,
      Showlabel,
      (row?.level1Text ? `${row?.level1Text}${row?.level2Text ? ", " : ""}` : "" ) + (row?.level2Text ? row?.level2Text : ""),
    );
  };

  const onSearchBtnPress = () => {
    if (!searchParam) {
      setError("Please enter a valid state, county, city, or zip code.");
    } else if (
      (searchParam &&
        searchParam.length > 0 &&
        autocomplete &&
        Object.keys(autocomplete)?.length === 0) ||
        autocompleteError !== ""
    ) {
      setError("Please enter a valid state, county, city, or zip code.");
    } else if (
      searchParam &&
      searchParam.length > 0 &&
      autocomplete &&
      Object.keys(autocomplete)?.length > 0
    ) {
      hitFirstAutocomplete();
    } else {
      setError("Please enter a valid state, county, city, or zip code.");
    }
    setSearchBarFocus(false);
    setShow(false);
  };

  const showError = () => {
    return (
      <div
        className={`search__control search__menu search__menu-list search__menu-list--error ${
          isSearchFromHome ? "search__control--home" : ""
        }`}
      >
        <div className="search-option search-option-container">
          <i>
            <span className="pl10 pt10 pb5 search__error--home number_of_line_one">
              {error}
            </span>
          </i>
        </div>
      </div>
    );
  };

  const renderInitialFocus = () => {
    if (
      !searchBarFocus ||
      (autocompleteError !== "" && searchParam.length > 1)
    ) {
      return null;
    }
    return (
      <div
        className={`search__control search__menu search__menu-list p-3 ${
          isSearchFromHome ? "search__control--home" : ""
        }`}
      >
        {getLocationRecentSearch()}
      </div>
    );
  };

  if (isSearchFromHome) {
    return (
      <>
        <div className="list-inline-item search-bar-wrapper">
          <div className="form-group">
            <div className="input-group search-bar-input-group">
              {!isMobile && (
                <div className="dropdown search-bar-dropdown">
                  <button
                    id="category-dropdown-btn-home"
                    className="btn btn-outline-secondary dropdown-toggle input-group-text search-bar-dropdown-btn"
                    type="button"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <span className="search-bar-dropdown-btn-text">{selectedCategory}</span>
                  </button>
                  {showDropdown && (
                    <ul className="dropdown-menu show search-bar-dropdown-menu">
                      {buyDropDown.map((item) => (
                        <li key={item.id} className="search-bar-dropdown-item-li">
                          <button
                            id={`category-item-home-${item.id}`}
                            className={`dropdown-item search-bar-dropdown-item ${selectedCategory === item.name ? 'search-bar-dropdown-item--active' : 'search-bar-dropdown-item--inactive'}`}
                            onClick={() => {
                              dispatch(setSearchLoading())
                              dispatch(setSelectedCategory(item.name));
                              setShowDropdown(false);
                            }}
                          >
                            {item.name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
              <div className="search-bar-input-wrapper">
                <input
                  type="text"
                  className={`form-control search-bar-input ${isMobile ? 'search-bar-input--mobile' : ''}`}
                  id="searchHome"
                  aria-label="Search"
                  placeholder={searchParam || (isMobile ? "Start your search here..." : selectedCategory === "Browse All" ? "Enter City, Address, Zip Code..." : "Enter State, City, Zip Code...")}
                  onChange={(e) => getAutocompleteData(e.target.value)}
                  value={searchParam}
                  maxLength={50}
                  autoComplete="off"
                  onFocus={() => {
                    setError("");
                    setSearchBarFocus(true);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onSearchBtnPress()
                    }
                  }}
                />
                <button
                  type="submit"
                  id="search-submit-btn-home"
                  className="btn search-bar-submit-btn"
                  aria-label="searchMenuBtn"
                  onClick={onSearchBtnPress}
                >
                  <span className="flaticon-magnifying-glass"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {!getShow && renderInitialFocus()}
        {autocomplete && getShow && renderAllAutocomplete()}
        {!!error && showError()}
      </>
    );
  } else {
    return (
      <div className="">
        <div className={`header_search_widget ${isMobile ? 'header_search_widget--mobile' : ''}`}>
          <div className="mailchimp_form">
            <div className="input-group search-bar-input-group--header">
              {!isMobile && (
                <div className="dropdown search-bar-dropdown">
                <button
                  id="category-dropdown-btn-header"
                  className="btn btn-outline-secondary dropdown-toggle input-group-text search-bar-dropdown-btn search-bar-dropdown-btn--header"
                  type="button"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <span className="search-bar-dropdown-btn-text">{selectedCategory}</span>
                </button>
                {showDropdown && (
                  <ul className="dropdown-menu show search-bar-dropdown-menu search-bar-dropdown-menu--header">
                    {buyDropDown.map((item) => (
                      <li key={item.id} className="search-bar-dropdown-item-li">
                        <button
                          id={`category-item-header-${item.id}`}
                          className={`dropdown-item search-bar-dropdown-item search-bar-dropdown-item--header ${selectedCategory === item.name ? 'search-bar-dropdown-item--active' : 'search-bar-dropdown-item--inactive'}`}
                          onClick={() => {
                             dispatch(setSearchLoading())
                            dispatch(setSelectedCategory(item.name));
                            setShowDropdown(false);
                          }}
                        >
                          {item.name}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
                </div>
              )}
              <div className="search-bar-input-wrapper">
                <input
                  type="text"
                  className={`form-control search-bar-input search-bar-input--header ${isMobile ? 'search-bar-input--mobile' : ''}`}
                  id="searchHomeheader"
                  aria-label="searchMenuHeader"
                  placeholder={searchParam || (isMobile ? "Start your search here..." : selectedCategory === "Browse All" ? "Enter City, Address, Zip code..." : "Enter State, City, Zip code...")}
                  onChange={(e) => getAutocompleteData(e.target.value)}
                  value={searchParam}
                  maxLength={50}
                  autoComplete="off"
                  onFocus={() => {
                    setError("");
                    setSearchBarFocus(true);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onSearchBtnPress()
                    }
                  }}
                />
                <button
                  type="submit"
                  id="search-submit-btn-header"
                  className="btn search-bar-submit-btn search-bar-submit-btn--header"
                  aria-label="searchMenuBtn"
                  onClick={onSearchBtnPress}
                >
                  <span className="flaticon-magnifying-glass search-bar-submit-icon--header"></span>
                </button>
              </div>
            </div>
          </div>
          {!getShow && renderInitialFocus()}
          {autocomplete && getShow && renderAllAutocomplete()}
          {!!error && showError()}
        </div>
      </div>
    );
  }
};

export default SearchBar;
